import { Component, ViewChild } from '@angular/core';
import { MenuComponent } from '@syncfusion/ej2-angular-navigations';
import { DashboardComponent } from '../routes/dashboard/dashboard.component';
import { AdminComponent } from '../routes/admin/admin.component';
import { CategoryAdminComponent } from '../routes/covariates/categories/categories.component';
import { GroupListAdminComponent } from '../routes/group-list/group-list.component';
import { UserListAdminComponent } from '../routes/user-list/user-list.component';
import { CovariatesAdminComponent } from '../routes/covariates/covariates.component';
import { IssuesListAdminComponent } from '../routes/admin/issues/issues-list.component';
import { ProviderListAdminComponent } from '../routes/admin/provider-list/provider-list.component';
import { ImportComponent } from '../routes/import/import.component';
import { ExportComponent } from '../routes/export/export.component';

@Component({
  selector: 'app-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss'],
})
export class MenuBarComponent {
  @ViewChild('menu')
  public menu!: MenuComponent;

  public menuItems: any[];
  public navigationId!: number;

  private routes = [
    {
      path: 'dashboard', component: DashboardComponent, text: 'Dashboard',
    },
    {
      path: 'group-list', component: GroupListAdminComponent, text: 'Groups',
    },
    {
      path: 'user-list', component: UserListAdminComponent, text: 'Users',
    },
    {
      path: 'location',  text: 'Locations',
      children: [
        { path: 'map', text: 'Map' },
      ]
    },
    {
      path: 'covariate', component: AdminComponent, text: 'Covariates',
      children: [
        { path: 'categories', component: CategoryAdminComponent, text: 'Categories' },
        { path: 'datasets', component: CovariatesAdminComponent, text: 'Datasets' },
      ]
    },
    {
      path: 'admin', component: AdminComponent, text: 'Admin',
      children: [
        { path: 'provider-list', component: ProviderListAdminComponent, text: 'Providers' },
        { path: 'issues-list', component: IssuesListAdminComponent, text: 'Issues' },
      ]
    },
    {
      path: 'import', component: ImportComponent, text: 'Import Data',
    },
    {
      path: 'export', component: ExportComponent, text: 'Export Data',
    },
  ];

  constructor() {
    this.menuItems = this.mapItems(this.routes);
  }

  // convert the routes to menu items.
  private mapItems(routes: any[], path?: string): any[] {
    return routes.map(menuItem => {
      const result: any = {
        text: menuItem.text,
        path: (path ? `${path}/` : '') + menuItem.path
      };
      if (menuItem.children) {
        result.items = this.mapItems(menuItem.children, menuItem.path);
      }
      return result;
    });
  }
}
